import { FindTheDifferencePuzzleModel, FindTheDifferenceQuestion } from "./FindTheDifferencePuzzleModel";

export class EagleEyeExamGameModel{

    rawData:any;

    quiz: FindTheDifferencePuzzleModel|null = null;

    constructor(rawData:any,fullScorePerQuestion:number,maxLife:number,practiceMode:boolean,timeLimitPerQuestion:number){
        this.rawData = rawData;
        this.parse(this.rawData,fullScorePerQuestion,maxLife,practiceMode,timeLimitPerQuestion);
    }
    //TODO: Add Null Checks
    parse(gameData:any,fullScorePerQuestion:number,maxLife:number,practiceMode:boolean,timeLimitPerQuestion:number):void{
        let questions:Array<FindTheDifferenceQuestion> = [];
        for (let index = 0; index < gameData.questions.length; index++) {
            const element = gameData.questions[index];
            let question: FindTheDifferenceQuestion = new FindTheDifferenceQuestion(element.id,
                    element.first_image_source,
                    element.second_image_source,
                    new Phaser.Math.Vector2(element.answer_x1,element.answer_y1),
                    new Phaser.Math.Vector2(element.answer_x2,element.answer_y2));
                questions.push(question);
        }
        this.quiz = new FindTheDifferencePuzzleModel(questions,fullScorePerQuestion,maxLife,practiceMode,timeLimitPerQuestion);
    }

    createRandomQuiz(questionCount:number,practiceMode?:boolean,fullScorePerQuestion?:number,maxLife?:number,timeLimitPerQuestion?:number):FindTheDifferencePuzzleModel{
        let questionCountTarget = Math.min(questionCount, this.quiz ? this.quiz.questions.length : questionCount);
        let randomQuestionIndexes = Phaser.Utils.Array.NumberArray(0,this.quiz!.questions.length-1);
        Phaser.Utils.Array.Shuffle(randomQuestionIndexes);
        let randomQuestions:FindTheDifferenceQuestion[] = [];
        for (let index = 0; index < questionCountTarget; index++) {
            const element = this.quiz ? this.quiz.questions[randomQuestionIndexes[index]]: null;
            if(element){
                randomQuestions.push(element);
            }
        }
        let _fullScorePerQuestion  = fullScorePerQuestion ? fullScorePerQuestion : (this.quiz ? (this.quiz.fullScorePerQuestion ? this.quiz.fullScorePerQuestion : 50) : 50);
        let _maxLife  = maxLife ? maxLife : (this.quiz ? (this.quiz.maxLife ? this.quiz.maxLife : 3) : 3);
        let _practiceMode = practiceMode ? practiceMode : (this.quiz ? (this.quiz.practiceMode ? this.quiz.practiceMode : false) : false);
        let _timeLimitPerQuestion = timeLimitPerQuestion ? timeLimitPerQuestion : (this.quiz ? (this.quiz.timeLimitPerQuestion ? this.quiz.timeLimitPerQuestion : 20) : 20);
        let result = new FindTheDifferencePuzzleModel(randomQuestions,_fullScorePerQuestion,_maxLife,_practiceMode,_timeLimitPerQuestion);
        return result;
    }

}